/* ============================================
   AJA Puzzle — Configurator (Stack Builder)
   Mejuri-style: dynamic rows, carousel arrows,
   per-ring size, layered composite preview.
   Real Shopify variants + cart line item properties.
   ============================================ */

(function () {
  'use strict';

  function init() {
    const root = document.querySelector('[data-puzzle-configurator]');
    if (!root) return;

    const productsScript = root.querySelector('[data-puzzle-products]');
    const configScript = root.querySelector('[data-puzzle-config]');
    if (!productsScript || !configScript) return;

    let products, config;
    try {
      products = JSON.parse(productsScript.textContent);
      config = JSON.parse(configScript.textContent);
    } catch (e) {
      console.error('[Puzzle Configurator] JSON parse error:', e);
      return;
    }
    console.log('[Puzzle Configurator] v2 stack-builder yüklendi · ürün sayısı:', products.length);
    if (!products.length) {
      console.warn('[Puzzle Configurator] Koleksiyonda ürün yok — satır oluşturulamadı.');
      return;
    }

    /* ---------- DOM refs ---------- */
    const rowsEl = root.querySelector('[data-puzzle-rows]');
    const addRowBtn = root.querySelector('[data-puzzle-add-row]');
    const stackEl = root.querySelector('[data-puzzle-stack]');
    const stackEmptyEl = root.querySelector('[data-puzzle-stack-empty]');
    const subtotalEl = root.querySelector('[data-puzzle-subtotal]');
    const discountRow = root.querySelector('[data-puzzle-discount-row]');
    const discountEl = root.querySelector('[data-puzzle-discount]');
    const totalEl = root.querySelector('[data-puzzle-total]');
    const discountHintEl = root.querySelector('[data-puzzle-discount-hint]');
    const addToCartBtn = root.querySelector('[data-puzzle-add-to-cart]');
    const saveBtn = root.querySelector('[data-puzzle-save]');
    const resetBtn = root.querySelector('[data-puzzle-reset]');

    const maxRings = config.max_rings || 5;
    const initialRings = Math.min(config.initial_rings || 3, maxRings);
    const overlap = Math.min(Math.max((config.stack_overlap || 62) / 100, 0), 0.92);
    const compositionId = 'puzzle-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);

    /* ---------- Product helpers ---------- */

    function sizeOptionIndex(product) {
      const names = product.options || [];
      const wanted = (config.size_option_name || 'Beden').toLowerCase();
      for (let i = 0; i < names.length; i++) {
        const n = String(names[i]).toLowerCase();
        if (n === wanted || /beden|size|ölçü|olcu/.test(n)) return i;
      }
      if (names.length === 1 && names[0] === 'Title') return -1;
      return names.length ? 0 : -1;
    }

    function sizesFor(product, sizeIdx) {
      if (sizeIdx < 0) return [];
      const key = 'option' + (sizeIdx + 1);
      const seen = Object.create(null);
      const out = [];
      product.variants.forEach(function (v) {
        const val = v[key];
        if (val && !seen[val]) { seen[val] = true; out.push(val); }
      });
      return out;
    }

    function resolveVariant(product, sizeIdx, sizeVal) {
      if (sizeIdx < 0 || !sizeVal) {
        return product.variants.find(function (v) { return v.available; }) || product.variants[0] || null;
      }
      const key = 'option' + (sizeIdx + 1);
      const matches = product.variants.filter(function (v) { return v[key] === sizeVal; });
      return matches.find(function (v) { return v.available; }) || matches[0] || null;
    }

    function stackImage(product) {
      return product.stack_image || product.featured_image || null;
    }

    /* ---------- State ---------- */
    // Each row: { ringIndex, size }
    let state = [];

    function makeRow(ringIndex) {
      const product = products[ringIndex];
      const sIdx = sizeOptionIndex(product);
      const sizes = sizesFor(product, sIdx);
      return {
        ringIndex: ringIndex,
        size: sizes.length ? sizes[0] : null
      };
    }

    function rowVariant(row) {
      const product = products[row.ringIndex];
      const sIdx = sizeOptionIndex(product);
      return resolveVariant(product, sIdx, row.size);
    }

    /* ---------- Render rows ---------- */

    function render() {
      rowsEl.innerHTML = '';

      state.forEach(function (row, i) {
        const product = products[row.ringIndex];
        const sIdx = sizeOptionIndex(product);
        const sizes = sizesFor(product, sIdx);
        const variant = rowVariant(row);
        const img = stackImage(product);

        const rowEl = document.createElement('div');
        rowEl.className = 'puzzle-row';

        /* prev arrow */
        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'puzzle-row-arrow';
        prev.setAttribute('aria-label', 'Önceki yüzük');
        prev.innerHTML = '&#8249;';
        prev.addEventListener('click', function () { cycleRing(i, -1); });

        /* center: image + info */
        const center = document.createElement('div');
        center.className = 'puzzle-row-center';

        const thumb = document.createElement('div');
        thumb.className = 'puzzle-row-thumb';
        if (img) {
          thumb.innerHTML = '<img src="' + img + '" alt="' + escapeHtml(product.title) + '">';
        } else {
          thumb.innerHTML = '<div class="puzzle-placeholder" style="width:100%;height:100%;font-size:10px">' + escapeHtml(product.title) + '</div>';
        }

        const info = document.createElement('div');
        info.className = 'puzzle-row-info';

        const name = document.createElement('div');
        name.className = 'puzzle-row-name';
        name.textContent = product.title;
        info.appendChild(name);

        const price = document.createElement('div');
        price.className = 'puzzle-row-price';
        if (variant && variant.available) {
          price.textContent = formatMoney(variant.price);
        } else if (variant && !variant.available) {
          price.textContent = 'Stokta yok';
          price.classList.add('is-unavailable');
        } else {
          price.textContent = '—';
        }
        info.appendChild(price);

        /* size selector */
        if (sizes.length) {
          const sizeWrap = document.createElement('div');
          sizeWrap.className = 'puzzle-row-size';

          const sizeLabel = document.createElement('span');
          sizeLabel.className = 'puzzle-row-size-label';
          sizeLabel.textContent = (config.size_option_name || 'Beden');
          sizeWrap.appendChild(sizeLabel);

          const select = document.createElement('select');
          select.className = 'puzzle-row-size-select';
          sizes.forEach(function (sz) {
            const opt = document.createElement('option');
            opt.value = sz;
            opt.textContent = sz;
            if (sz === row.size) opt.selected = true;
            select.appendChild(opt);
          });
          select.addEventListener('change', function () {
            state[i].size = select.value;
            update();
          });
          sizeWrap.appendChild(select);
          info.appendChild(sizeWrap);
        }

        center.appendChild(thumb);
        center.appendChild(info);

        /* next arrow */
        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'puzzle-row-arrow';
        next.setAttribute('aria-label', 'Sonraki yüzük');
        next.innerHTML = '&#8250;';
        next.addEventListener('click', function () { cycleRing(i, 1); });

        /* delete */
        const del = document.createElement('button');
        del.type = 'button';
        del.className = 'puzzle-row-del';
        del.setAttribute('aria-label', 'Yüzüğü kaldır');
        del.innerHTML = trashSvg();
        del.disabled = state.length <= 1;
        del.addEventListener('click', function () { removeRow(i); });

        rowEl.appendChild(prev);
        rowEl.appendChild(center);
        rowEl.appendChild(next);
        rowEl.appendChild(del);
        rowsEl.appendChild(rowEl);
      });

      addRowBtn.disabled = state.length >= maxRings;
      renderPreview();
      renderTotals();
    }

    /* ---------- Composite preview ---------- */

    function renderPreview() {
      stackEl.innerHTML = '';
      let count = 0;
      state.forEach(function (row, i) {
        const product = products[row.ringIndex];
        const img = stackImage(product);
        if (!img) return;
        const layer = document.createElement('img');
        layer.className = 'puzzle-stack-layer';
        layer.src = img;
        layer.alt = '';
        layer.style.zIndex = String(i + 1);
        layer.addEventListener('load', layoutStack);
        stackEl.appendChild(layer);
        count++;
      });
      if (stackEmptyEl) stackEmptyEl.style.display = count ? 'none' : 'flex';
      layoutStack();
    }

    function layoutStack() {
      const layers = Array.prototype.slice.call(stackEl.querySelectorAll('.puzzle-stack-layer'));
      if (!layers.length) { stackEl.style.height = '0px'; return; }
      const w = stackEl.clientWidth || stackEl.offsetWidth;
      if (!w) return;
      // assume square-ish; use first layer natural aspect if available
      const first = layers[0];
      let layerH = w;
      if (first.naturalWidth && first.naturalHeight) {
        layerH = w * (first.naturalHeight / first.naturalWidth);
      }
      const step = layerH * (1 - overlap);
      layers.forEach(function (img, i) {
        img.style.top = (i * step) + 'px';
      });
      stackEl.style.height = (layerH + (layers.length - 1) * step) + 'px';
    }

    /* ---------- Totals ---------- */

    function renderTotals() {
      const selected = state
        .map(rowVariant)
        .filter(function (v) { return v && v.available; });

      const count = selected.length;
      const subtotal = selected.reduce(function (sum, v) { return sum + v.price; }, 0);

      const meets = count >= config.discount_min_items;
      const discount = meets ? Math.round(subtotal * (config.discount_percent / 100)) : 0;
      const total = subtotal - discount;

      if (count === 0) {
        subtotalEl.textContent = '—';
        totalEl.textContent = '—';
        discountRow.style.display = 'none';
        discountHintEl.textContent = '';
        addToCartBtn.disabled = true;
        return;
      }

      subtotalEl.textContent = formatMoney(subtotal);
      totalEl.textContent = formatMoney(total);

      if (meets) {
        discountRow.style.display = 'flex';
        discountEl.textContent = '−' + formatMoney(discount);
        discountHintEl.textContent = '';
      } else {
        discountRow.style.display = 'none';
        const remaining = config.discount_min_items - count;
        discountHintEl.textContent = remaining > 0
          ? remaining + ' yüzük daha eklersen %' + config.discount_percent + ' stack indirimi otomatik uygulanır.'
          : '';
      }

      addToCartBtn.disabled = false;
    }

    /* ---------- Mutations ---------- */

    function cycleRing(rowIndex, dir) {
      const n = products.length;
      let idx = (state[rowIndex].ringIndex + dir + n) % n;
      const product = products[idx];
      const sIdx = sizeOptionIndex(product);
      const sizes = sizesFor(product, sIdx);
      // keep current size if the new product offers it, else first
      const curSize = state[rowIndex].size;
      state[rowIndex].ringIndex = idx;
      state[rowIndex].size = (curSize && sizes.indexOf(curSize) !== -1) ? curSize : (sizes[0] || null);
      update();
    }

    function addRow() {
      if (state.length >= maxRings) return;
      // start new row on a ring not already in the stack, if possible
      const used = state.map(function (r) { return r.ringIndex; });
      let idx = 0;
      for (let i = 0; i < products.length; i++) {
        if (used.indexOf(i) === -1) { idx = i; break; }
      }
      state.push(makeRow(idx));
      update();
    }

    function removeRow(rowIndex) {
      if (state.length <= 1) return;
      state.splice(rowIndex, 1);
      update();
    }

    function update() {
      render();
    }

    addRowBtn.addEventListener('click', addRow);

    /* ---------- Add to cart ---------- */

    addToCartBtn.addEventListener('click', function () {
      const items = state
        .map(rowVariant)
        .filter(function (v) { return v && v.available; })
        .map(function (v) {
          return {
            id: v.id,
            quantity: 1,
            properties: { _puzzle_composition_id: compositionId }
          };
        });

      if (!items.length) return;

      addToCartBtn.disabled = true;
      const original = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Ekleniyor...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { if (!res.ok) throw new Error('Sepete eklenemedi'); return res.json(); })
        .then(function () { window.location.href = config.cart_url || '/cart'; })
        .catch(function (err) {
          console.error('[Puzzle Configurator] Cart error:', err);
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = original;
          alert('Sepete eklenirken bir hata oluştu. Lütfen tekrar dene.');
        });
    });

    /* ---------- Save / share ---------- */

    saveBtn.addEventListener('click', function () {
      const variantIds = state
        .map(rowVariant)
        .filter(Boolean)
        .map(function (v) { return v.id; });
      if (!variantIds.length) { alert('Önce en az bir yüzük seç.'); return; }

      const url = new URL(window.location.href);
      url.hash = 'configure';
      url.searchParams.set('puzzle', variantIds.join(','));
      const shareUrl = url.toString();

      if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl).then(function () {
          saveBtn.textContent = 'Bağlantı kopyalandı';
          setTimeout(function () { saveBtn.textContent = 'Kompozisyonu kaydet'; }, 2400);
        }).catch(function () { window.prompt('Kompozisyon bağlantısı:', shareUrl); });
      } else {
        window.prompt('Kompozisyon bağlantısı:', shareUrl);
      }
    });

    /* ---------- Reset ---------- */

    resetBtn.addEventListener('click', function () {
      buildInitial();
      update();
      const url = new URL(window.location.href);
      url.searchParams.delete('puzzle');
      window.history.replaceState({}, '', url.toString());
    });

    /* ---------- Init from URL or defaults ---------- */

    function findByVariantId(variantId) {
      for (let i = 0; i < products.length; i++) {
        const v = products[i].variants.find(function (vv) { return vv.id === variantId; });
        if (v) {
          const sIdx = sizeOptionIndex(products[i]);
          const size = sIdx >= 0 ? v['option' + (sIdx + 1)] : null;
          return { ringIndex: i, size: size };
        }
      }
      return null;
    }

    function buildFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const puzzleParam = params.get('puzzle');
      if (!puzzleParam) return false;
      const ids = puzzleParam.split(',').map(function (s) { return parseInt(s, 10); }).filter(Boolean);
      const rows = [];
      ids.forEach(function (id) {
        const r = findByVariantId(id);
        if (r && rows.length < maxRings) rows.push(r);
      });
      if (!rows.length) return false;
      state = rows;
      return true;
    }

    function buildInitial() {
      state = [];
      for (let i = 0; i < initialRings; i++) {
        state.push(makeRow(i % products.length));
      }
    }

    if (!buildFromUrl()) buildInitial();
    render();

    window.addEventListener('resize', layoutStack);

    /* ---------- Utilities ---------- */

    function formatMoney(cents) {
      const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return '₺ ' + value;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function trashSvg() {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"/><path d="M10 11v6M14 11v6"/></svg>';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
